
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import cuentas from './lista-buscador-cuentas.vue';
    import filtros from './lista-buscador-filtros.vue';
    import listados from './lista-buscador-listados.vue';
    import { ControladorSeccion } from '../../pc/lista/controlador';
import { Wait } from '@/__env/ext';

    @Component( {
        name: "Componente",
        props: {},
        components: {
            filtros,
            cuentas,
            listados,
        }
    } )
    export default class Componente extends Vue
    {
        @Prop()
        public Controlador: ControladorSeccion;
        public get Buscador() { return this.Controlador.Buscador; }
        public get Estado() { return this.Controlador.Buscador.Estado; }
        public get Items() { return this.Controlador.Buscador.Items; }
        public get Seleccionados() { return this.Controlador.Seleccionados; }


        public ActivaBusqueda: boolean = false;
        public AlternarBusqueda()
        {
            if ( this.ActivaBusqueda )
            {
                this.Busqueda = '';
            }
            this.ActivaBusqueda = !this.ActivaBusqueda;
        }

        public Busqueda: string = '';
        @Watch( 'Busqueda' )
        public async onBusqueda()
        {
            let bb = this.Busqueda;
            await Wait( 600 );
            if ( bb == this.Busqueda )
            {
                this.Buscar();
            }

        }

        public Buscar( forzar?: boolean )
        {
            if ( forzar )
                this.Busqueda = '';
            this.Buscador.Filtros.Busqueda = this.Busqueda;
            this.Buscador.Buscar( 1 );
        }

        AbrirEditarPrecios()
        {
            this.$router.push( '/mercadolibre/publicaciones/precios' );
        }
    }
